import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import React, { FC } from 'react';
import styles from './more-actions.module.css';

export const IconMoreActions: FC = () => {
  return (
    <div className={styles.icon} style={{ color: 'var(--icon-primary)' }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color="var(--icon-primary)"
      >
        <path d="M6 8H3V9H6V8Z" fill="currentColor" />
        <path d="M8 6H3V7H8V6Z" fill="currentColor" />
        <path d="M8 4H3V5H8V4Z" fill="currentColor" />
        <path
          d="M7 13H2V3H14V8H15V3C15 2.73478 14.8946 2.48043 14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2H2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V13C1 13.2652 1.10536 13.5196 1.29289 13.7071C1.48043 13.8946 1.73478 14 2 14H7V13Z"
          fill="currentColor"
        />
        <path
          d="M13 10H12V12H10V13H12V15H13V13H15V12H13V10Z"
          fill="currentColor"
        />
      </svg>
      <CaretDown16 />
    </div>
  );
};
